'use client';

import { ChakraProps, chakra } from '@chakra-ui/react';

export const Unauthorized = () => {
  const highlight: ChakraProps['color'] = 'dynamic.highlight';

  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 598.38259 519.36575"
    >
      <chakra.path
        d="M554.03 481.345l16.118-5.113a54.561 54.561 0 00-.388-26.249c-6.476 14.399-25.475 17.926-36.3 29.419a32.819 32.819 0 00-8.395 27.18l-3.392 11.503a54.994 54.994 0 0040.024-22.767 53.121 53.121 0 006.225-11.783c-6.874-.689-13.893-2.19-13.893-2.19z"
        fill="#f2f2f2"
      />
      <chakra.path
        d="M536.805 460.072l12.147-11.765a54.561 54.561 0 00-12.054-23.32c.625 15.775-14.806 27.406-19.37 42.52a32.819 32.819 0 004.608 28.07l2.095 11.81a54.994 54.994 0 0025.67-38.228 53.12 53.12 0 00.315-13.323c-6.46 2.45-13.41 4.236-13.41 4.236z"
        fill="#f2f2f2"
      />
      <chakra.path
        d="M456.06 34.484H1.767a1.807 1.807 0 010-3.613H456.06a1.807 1.807 0 010 3.613z"
        fill="#3f3d56"
      />
      <chakra.ellipse
        cx={32.69152}
        cy={10.82345}
        rx={10.58751}
        ry={10.82345}
        fill="#3f3d56"
      />
      <chakra.ellipse
        cx={69.26654}
        cy={10.82345}
        rx={10.58751}
        ry={10.82345}
        fill="#3f3d56"
      />
      <chakra.ellipse
        cx={105.84156}
        cy={10.82345}
        rx={10.58751}
        ry={10.82345}
        fill="#3f3d56"
      />
      <chakra.path
        d="M434.039 2.683h-25.981a1.968 1.968 0 000 3.934h25.981a1.968 1.968 0 000-3.934zM434.039 10.067h-25.981a1.968 1.968 0 000 3.935h25.981a1.968 1.968 0 000-3.935zM434.039 17.442h-25.981a1.968 1.968 0 000 3.934h25.981a1.968 1.968 0 000-3.934z"
        fill="#3f3d56"
      />
      <chakra.circle cx={35.19338} cy={94.79521} r={13.08937} fill="#e6e7e8" />
      <chakra.path
        d="M368.516 123.78H26.002a3.898 3.898 0 110-7.796h342.514a3.898 3.898 0 110 7.796zM278.686 139.182H26.002a3.898 3.898 0 010-7.796h252.684a3.898 3.898 0 110 7.796z"
        fill="#e6e7e8"
      />
      <chakra.circle cx={35.19338} cy={299.09983} r={13.08937} fill="#e6e7e8" />
      <chakra.path
        d="M368.516 328.084H26.002a3.898 3.898 0 110-7.795h342.514a4.36 4.36 0 014.114 4.198 3.85 3.85 0 01-4.114 3.597zM278.686 343.486H26.002a3.898 3.898 0 010-7.796h252.684a3.898 3.898 0 110 7.796z"
        fill="#e6e7e8"
      />
      <chakra.circle cx={35.19338} cy={189.24655} r={13.08937} fill="#e6e7e8" />
      <chakra.path
        d="M368.516 218.231H26.002a3.898 3.898 0 110-7.796h342.514a3.898 3.898 0 110 7.796zM320.818 233.633H26.002a3.898 3.898 0 010-7.796h294.816a3.898 3.898 0 010 7.796zM300.808 249.035H26.002a3.898 3.898 0 010-7.796h274.806a3.898 3.898 0 110 7.796z"
        fill="#e6e7e8"
      />
      <chakra.circle
        cx={306.49461}
        cy={324.42079}
        r={96.9336}
        fill={highlight}
      />
      <chakra.circle
        cx={306.36146}
        cy={344.39338}
        r={13.84766}
        fill="#3f3d56"
      />
      <chakra.circle
        cx={306.36146}
        cy={344.39338}
        r={6.39123}
        fill={highlight}
      />
      <chakra.path
        d="M332.067 375.219h-51.144a19.123 19.123 0 01-19.102-19.101v-23.45a19.123 19.123 0 0119.102-19.1h51.144a19.123 19.123 0 0119.1 19.1v23.45a19.122 19.122 0 01-19.1 19.1zm-51.144-59.652a17.121 17.121 0 00-17.102 17.102v23.449a17.12 17.12 0 0017.102 17.1h51.144a17.12 17.12 0 0017.1-17.1v-23.45a17.12 17.12 0 00-17.1-17.1z"
        fill="#fff"
      />
      <chakra.path
        d="M277.894 362.49h45.395a17.943 17.943 0 0017.943-17.943v-19.623a17.863 17.863 0 00-1.184-6.365 17.895 17.895 0 017.131 14.295v19.623a17.943 17.943 0 01-17.943 17.943h-45.395a17.933 17.933 0 01-16.759-11.578 17.84 17.84 0 0010.812 3.648z"
        fill="#3f3d56"
      />
      <chakra.path
        fill="#a0616a"
        d="M416.909 506.542L405.755 506.541 400.448 463.514 416.912 463.515 416.909 506.542z"
      />
      <chakra.path
        d="M417.303 518.178H383v-.435a13.352 13.352 0 0113.351-13.351h.001l6.266-4.754 11.69 4.755h2.995z"
        fill="#2f2e41"
      />
      <chakra.path
        fill="#a0616a"
        d="M495.838 506.542L506.993 506.541 512.3 463.514 495.836 463.515 495.838 506.542z"
      />
      <chakra.path
        d="M495.445 518.178h34.303v-.435a13.352 13.352 0 00-13.352-13.351l-6.266-4.754-11.69 4.755h-2.995zM399.957 431.896c.165-2.455 1.475-16.033 1.475-16.033l3.137-28.794 5.53-76.328.361-4.997 28.967-5.561 19.798-9.491 23.531 7.522 18.324 6.871s.03 2.942.172 6.495c.188 4.651.518 10.354 1.302 11.836 1.31 2.62.98 16.684.98 16.684s1.303 28.614 2.942 31.752 1.969 9.671 1.475 10.981 1.639 35.674 1.639 35.674 5.476 60.81 2.04 69.98-16.418 3.163-16.418 3.163.628-2.447-3.137-3.6-15.233-87.38-15.233-87.38-2.133-17.68-4.094-22.747-3.765-19.304-3.765-19.304-12.111-23.563-12.268-28.802c0 0-1.585-4.903-3.083.494s-5.914 18.323-5.914 18.323l-4.306 15.876-5.067 23.72-3.279 19.97s-4.91 26.504-5.695 27.65 0 25.358 0 25.358-3.796 20.622-9.161 24.222-19.58.057-19.58.057-.838-51.136-.673-53.59z"
        fill="#2f2e41"
      />
      <chakra.path
        fill="#2f2e41"
        d="M412.315 236.13L418.755 255.528 410.809 264.987 414.308 268.588 411.727 273.678 404.997 327.032 441.894 341.025 454.319 325.447 464.116 341.025 506.81 330.593 495.922 262.556 495.922 258.108 492.848 249.519 492.848 231.337 500.966 177.215 476.736 168.728 465.151 159.559 461.402 172.454 445.44 169.615 445.024 159.927 432.811 171.466 422.527 174.399 410.213 177.215 408.644 181.137 411.781 180.353 411.272 231.377 412.315 236.13z"
      />
      <chakra.path
        d="M401.286 307.104l6.197-59.982 1.636-24.686-17.345-3.136s.687 17.651-1.585 27.61c-2.242 9.828-.297 58.877-.159 60.189a8.439 8.439 0 1011.256.005z"
        fill="#a0616a"
      />
      <chakra.path
        d="M384.368 259.552l4.824.996 16.55 3.427.918.189 1.953-7.766 2.267-2.416 4.314-22.605.227-1.177 6.519-13.93 4.51-41.87-16.77 3.011c-.087.086-.166.18-.244.275-2.408 2.73-4.126 6.526-6.934 10.346-9.138 12.432-16.15 42.639-15.875 59.19.008.266-.267.556-.596.854a9.18 9.18 0 00-1.663 11.476z"
        fill="#2f2e41"
      />
      <chakra.path
        d="M509.108 307.104l-6.197-59.982-1.635-24.686 17.345-3.136s-.688 17.651 1.585 27.61c2.242 9.828.297 58.877.158 60.189a8.439 8.439 0 11-11.256.005z"
        fill="#a0616a"
      />
      <chakra.path
        d="M526.027 259.552l-4.824.996-16.55 3.427-.918.189-1.953-7.766-2.267-2.416-4.314-22.605-.228-1.177-6.518-13.93 1.49-41.87 10.77 3.011c.087.086.165.18.244.275 2.408 2.73 4.125 6.526 6.933 10.346 9.138 12.432 16.15 42.639 15.876 59.19-.008.266.266.556.596.854a9.18 9.18 0 011.663 11.476z"
        fill="#2f2e41"
      />
      <chakra.path
        d="M437.144 180.594l7.88-20.667 20.127-.368 6.679 21.035 24.006 134.104s-73.544 20.48-72.798-4.138c.784-25.885 4.323-60.268 4.323-60.268z"
        fill={highlight}
      />
      <chakra.circle
        cx={454.63748}
        cy={130.43677}
        r={23.70998}
        fill="#a0616a"
      />
      <chakra.path
        d="M429.53 113.237c3.86-4.202 8.688-11.892 23.312-15.122 18.07-3.99 26.609 12.334 22.052 12.601 13.325 4.035 4.765 31.61.945 29.298a1.125 1.125 0 01-.095-.073 18.77 18.77 0 01-7.497-12.807l-.725-6.525c-.103 5.309-5.53 6.011-11.074 4.056a6.955 6.955 0 014.914-4.838 23.786 23.786 0 01-13.972 6.079 9.51 9.51 0 014.626-6.364l-.22-.215a22.85 22.85 0 01-7.33 4.15c-3.055.876-6.717.402-8.81-1.99a6.5 6.5 0 01-1.253-2.254c.452 4.204-2.368 9.004-4.559 8.18-1.822-.354-2.884-11.38-.315-14.176z"
        fill="#2f2e41"
      />
      <chakra.path
        d="M598.383 518.176a1.186 1.186 0 01-1.19 1.19h-280.29a1.19 1.19 0 010-2.38h280.29a1.187 1.187 0 011.19 1.19z"
        fill="#ccc"
      />
      <chakra.path
        d="M307.282 271.863c-9.481 0-17.815 4.292-22.533 10.734a29.121 29.121 0 0117.373-5.574c14.681 0 26.626 10.284 26.626 22.925v10.508h5.16v-15.668c0-12.641-11.945-22.925-26.626-22.925z"
        fill="#3f3d56"
      />
      <chakra.path
        d="M337.453 315.834h-61.918v-18.218c0-14.698 13.889-26.656 30.96-26.656s30.958 11.958 30.958 26.656zm-59.918-2h57.918v-16.218c0-13.596-12.99-24.656-28.959-24.656s-28.959 11.06-28.959 24.656z"
        fill="#fff"
      />
      <chakra.path
        d="M322.352 308.879h-31.715a5.388 5.388 0 01-5.381-5.382v-7.25c0-10.108 9.528-18.332 21.238-18.332s21.24 8.224 21.24 18.332v7.25a5.388 5.388 0 01-5.382 5.382zm-15.857-28.964c-10.609 0-19.24 7.326-19.24 16.332v7.25a3.385 3.385 0 003.382 3.382h31.715a3.385 3.385 0 003.381-3.382v-7.25c0-9.006-8.63-16.332-19.238-16.332z"
        fill="#fff"
      />
    </chakra.svg>
  );
};
